// tslint:disable:one-line

import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { DialogAlertApiComponent } from '../components/dialog-alert-api/dialog-alert-api.component';
import { DialogAlertApi400Component } from '../components/dialog-alert-api-400/dialog-alert-api-400.component';
import { settings } from 'app/app.settings';

export interface ApiErrorInterceptorConfig {
  skipErrorStatuses: [ number ];
}

@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    public dialog: MatDialog
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let interceptorConfig: any = {};

    if (request.params.get('interceptorConfig')) {
      interceptorConfig = request.params.get('interceptorConfig');
    }

    if (request.body && request.body.interceptorConfig) {
      interceptorConfig = request.body.interceptorConfig || {};
      delete request.body.interceptorConfig;
    }

    const clonedRequest = request.clone({
      params: request.params.delete('interceptorConfig')
    });

    return next.handle(clonedRequest).pipe(catchError(error => {
      if (interceptorConfig.skipErrorStatuses) {
        if (interceptorConfig.skipErrorStatuses.indexOf(error.status) !== -1) {
          return observableThrowError(error);
        }
      }

      if ([ 401, 403, 422 ].indexOf(error.status) > -1) {
        if (settings.app.SSOEnabled) {
          location.reload();
        } else if (error.url.indexOf('auth/saml/sso') > -1) {
          this.router.navigateByUrl('/login-sso');
        } else {
          this.router.navigateByUrl('/login');
        }
      }

      else if (error.status === 404) {
        this.router.navigateByUrl('/404', { skipLocationChange: true });
      }

      else if (!error.status || error.status >= 400) {
        let Dialog: any, message: string;

        if (error.status === 400) {
          Dialog = DialogAlertApi400Component;
          message = JSON.stringify(error.error, null, 0).replace(/":/g, ': ').replace(/[\[\]\{\}"]/g, '');
        } else {
          Dialog = DialogAlertApiComponent;
          message = `${error.status}: ${error.statusText}`;
        }

        if (!document.getElementById('dialog-unique')) {
          this.dialog.open(Dialog, {
            width: '400px',
            id: 'dialog-unique',
            data: {
              message: message
            }
          });
        }
      }

      return observableThrowError(error);
    }));
  }
}
